import UserActiveStateProvider from "./user-active-state-provider";

export default class UserActiveStateProviderFactory {
  public constructor(private fWindow: Window) {}

  public create(): UserActiveStateProvider {
    return new UserActiveStateProvider(this.fWindow);
  }
}
